"use client";

import { registerHashScrollAdapter } from "@v2/helpers/hashScroll";
import { useEffect } from "react";
import { scrollToPlpSection, scrollToPlpSectionWhenSettled } from "./plpSectionScroll";

/**
 * Says how the sections of a product list page are reached, for as long as one is on
 * screen. The site-wide listener does the rest: it never has to know that this page
 * has a sticky toolbar the list has to come to rest under.
 */
export default function PlpSectionScrollAdapter() {
    useEffect(() => registerHashScrollAdapter({
        scroll: scrollToPlpSection,
        scrollWhenSettled: scrollToPlpSectionWhenSettled,
    }), []);

    return null;
}
